import * as theme from "../theme";

import Button from "@mui/material/Button";
import styled from "styled-components";
import bbbLogo from '../assets/images/bbb_logo.webp';
import ReverseContent from "./ReverseContent";

const CustomButton = ({ text, onClick, disabled, showContent, hideBBB }) => {

  return (
    <>
      <StyledButton variant="contained" onClick={onClick} disabled={disabled}>
        {text || "Next"}
      </StyledButton>
      {!hideBBB && <BBBRatingLogoContainer>
        <BBBRatingLogo src={bbbLogo} alt="BBB Accredited Business" />
      </BBBRatingLogoContainer>}
      {showContent && <ReverseContent />}
    </>
  );
};

const StyledButton = styled(Button)`
  background-color: ${theme.primary} !important;
  opacity: ${(p) => p.disabled && "0.8"};
  color: ${theme.white} !important;
  width: 416px !important;
  text-transform: capitalize !important;
  height: 48px !important;

  @media (max-width: ${theme.mobile}) {
    width: 330px !important;
  }
`;

const BBBRatingLogoContainer = styled.div`
    width: 200px;
    margin: 25px 0;
    padding: 18px 0 30px 0;
`;

const BBBRatingLogo = styled.img`
    width: 100%;
    opacity: 0.8;
`;

export default CustomButton;
